// Author Lin
// Date 2021-11-04 10:51:28

class MintalMesPrdSubstationPowerRecord {
constructor({
        id = null,
        recordTime = '',
        pointId = '',
        pointName = '',
        activeReading = '',
        electricity = '',
        reactiveReading = '',
        recorderId = '',
        recorder = '',
        reviewerId = '',
        reviewer = '',
        remark = ''}
= {}) {
    this.id = id;
    this.recordTime = recordTime;
    this.pointId = pointId;
    this.pointName = pointName;
    this.activeReading = activeReading;
    this.electricity = electricity;
    this.reactiveReading = reactiveReading;
    this.recorderId = recorderId;
    this.recorder = recorder;
    this.reviewerId = reviewerId;
    this.reviewer = reviewer;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdSubstationPowerRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'recordTime',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.recordTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pointId',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.pointId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pointName',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.pointName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'activeReading',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.activeReading',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electricity',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.electricity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reactiveReading',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.reactiveReading',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'recorderId',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.recorderId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'recorder',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.recorder',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reviewerId',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.reviewerId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reviewer',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.reviewer',
        sortable: true,
        isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    recordTimeRteFilter : '',
    recordTimeLteFilter : '',
    pointIdFilter : '',
    pointNameFilter : '',
    activeReadingFilter : '',
    electricityFilter : '',
    reactiveReadingFilter : '',
    recorderIdFilter : '',
    recorderFilter : '',
    reviewerIdFilter : '',
    reviewerFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'recordTimeRteFilter',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.filter.recordTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'recordTimeLteFilter',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.filter.recordTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'pointNameFilter',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.filter.pointName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstSubstationPoint'
            ,correspondingField: 'pointName'
            ,fieldsBindingByEntityModalSelected: '{"pointId":"id"}'
                }
        },
        {
        key: 'recorderFilter',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.filter.recorder',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'recordTime',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.entity.recordTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'pointName',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.entity.pointName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstSubstationPoint'
            ,correspondingField: 'pointName'
            ,fieldsBindingByEntityModalSelected: '{"pointId":"id"}'
                }
        },
        {
        key: 'activeReading',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.entity.activeReading',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'electricity',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.entity.electricity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'reactiveReading',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.entity.reactiveReading',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'recorder',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.entity.recorder',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdSubstationPowerRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdSubstationPowerRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
